/* eslint-disable camelcase */

import loadable from '@loadable/component';

import keywordSearchPageQuery from './query.graphql';

// const KeywordLandingPage = loadable(() =>
//   import(/* webpackChunkName: "search" */ '../search/components/results')
// );

// const KeywordLandingPage = loadable(() =>
//   import(/* webpackChunkName: "search" */ './components/results')
// );

const KeywordLandingPage = loadable(() =>
  import(/* webpackChunkName: "search" */ './components/index')
);

export const queryToVariables = vars => {
  const {
    offset = 0,
    slug = '',
    query = '',
    category_id = '',
    brand_id = '',
    lowest_price = '',
    user_rating = '',
    experiments,
  } = vars;
  return {
    id: 'search',
    query,
    slug,
    offset: parseInt(offset, 10),
    limit: 48,
    filters: [
      { id: 'category_id', selected: category_id.split(',').filter(Boolean) },
      { id: 'brand_id', selected: brand_id.split(',').filter(Boolean) },
      {
        id: 'lowest_price',
        from: parseInt(lowest_price.split(',')[0], 10) || undefined,
        to: parseInt(lowest_price.split(',')[1], 10) || undefined,
      },
      {
        id: 'user_rating',
        from: parseInt(user_rating.split(',')[0], 10) || undefined,
        to: parseInt(user_rating.split(',')[1], 10) || undefined,
      },
    ],
    productModes: ['product', 'raw'],
    newSearch:
      experiments['new-search-index-kwlp'] &&
      experiments['new-search-index-kwlp'].selectedVariant === 'new',
    categoryFilters: category_id.split(',').filter(Boolean),
    brandFilters: brand_id.split(',').filter(Boolean),
  };
};

const fetchProducts = variables => async ({ dispatch, graphql }) => {
  const { data } = await graphql(keywordSearchPageQuery, variables);
  if (!data) {
    return;
  }
  dispatch({
    type: 'PRODUCTS_RECEIVED',
    data,
  });
};

KeywordLandingPage.reducer = (state, action) => {
  switch (action.type) {
    case 'SSR':
    case 'ROUTE_LOADED': {
      if (action && action.route && action.route.variables) {
        return { ...state, variables: action.route.variables };
      }
      return state;
    }
    case 'FETCH_PRODUCTS': {
      const { variables } = action;
      return fetchProducts({ ...variables });
    }
    case 'PRODUCTS_RECEIVED': {
      const { data } = action;
      return { ...state, data };
    }
    default: {
      return state;
    }
  }
};

KeywordLandingPage.variables = queryToVariables;

KeywordLandingPage.graphQL = keywordSearchPageQuery;

KeywordLandingPage.loadOrder = [{}];

KeywordLandingPage.group = ({ name, variables }) => {
  const groupVariables = variables
    ? Object.keys(variables)
        .filter(key => ['query', 'offset'].indexOf(key) > -1)
        .map(key => variables[key])
    : [];

  const filterVariables =
    variables && variables.filters
      ? variables.filters.map(filter => {
          switch (filter.id) {
            case 'category_id':
            case 'brand_id':
              return `${filter.id}:${filter.selected}`;
            case 'lowest_price':
            case 'user_rating':
              return `${filter.id}:${filter.from}:${filter.to}`;
            default:
              return filter.id;
          }
        })
      : [];

  return `${name}_${groupVariables.join('_')}_${filterVariables.join('_')}`;
};

export default KeywordLandingPage;
